const breakpoints = {
  phone: '480px',
  tablet: '768px',
  laptop: '1100px',
};

export default breakpoints;
